var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "bg-white" },
      [
        _c(
          "div",
          { staticClass: "pt-10 ml-10 flex align-center" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "medium", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      path: "/tutorial/edit?type=" + _vm.type,
                    })
                  },
                },
              },
              [_vm._v("添加" + _vm._s(_vm.title))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "ptd-5",
            attrs: {
              id: "order_table",
              data: _vm.list,
              "element-loading-text": "Loading",
              stripe: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "封面图" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-image", {
                        staticStyle: { width: "60px", height: "60px" },
                        attrs: { src: scope.row.img_url, fit: "cover" },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "标题" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "el-link" }, [
                        _vm._v(_vm._s(scope.row.title)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "时间" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.parseTime(
                              scope.row.add_date,
                              "{y}-{m}-{d} {h}:{i}"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "el-link" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "查看范围" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(scope.row.throw_agent_level, function (item) {
                      return _c("span", [_vm._v(_vm._s(_vm.roles[item]) + ",")])
                    })
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.shelves(scope.row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(scope.row.is_show == 0 ? "已下架" : "已上架")
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0 mt-5" }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                path:
                                  "/tutorial/edit?id=" +
                                  scope.row.id +
                                  "&type=" +
                                  _vm.type,
                              })
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem({
                                id: scope.row.id,
                                index: scope.$index,
                              })
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-center" },
          [
            _c("pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listQuery.page_num > 0,
                  expression: "listQuery.page_num > 0",
                },
              ],
              attrs: {
                page: _vm.listQuery.start,
                limit: _vm.listQuery.limit,
                "page-count": _vm.listQuery.page_num,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "start", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "limit", $event)
                },
                pagination: _vm.getList,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }